import { H5LIVE_VIEW, MOQ_VIEW } from '../../../constants/general';
import { H5LIVE_SETTINGS } from '../../zoom/widgetSettings/H5liveView';
import { MOQ_SETTINGS } from '../../zoom/widgetSettings/MoqView';

// The H5Live and the MOQ tab show the same player metrics: the player reports one identical metric
// set and only names the used playback API, so both tabs are served by the same backend controllers
// under mirrored routes (/v2/h5live/... and /v2/moq/...). The widgets in this folder therefore take a
// 'view' prop, defaulting to H5Live, build their request path as /v2/<view>/... - the view name is
// the API namespace - and read everything else that differs per tab from here.
export const PLAYBACK_VIEWS = {
   [H5LIVE_VIEW]: {
      label: 'H5Live',
      csvPrefix: 'H5live',
      zoomSettings: H5LIVE_SETTINGS,
   },
   [MOQ_VIEW]: {
      label: 'MOQ',
      csvPrefix: 'Moq',
      zoomSettings: MOQ_SETTINGS,
   },
};

export const PLAYBACK_VIEW_NAMES = Object.keys(PLAYBACK_VIEWS);

/**
 * Resolves everything a playback widget needs for the tab it renders for.
 *
 * Deliberately throws on an unknown view instead of falling back to a default: a mistyped view
 * silently rendering the other tab's numbers would be far worse than a hard failure.
 */
export function playbackViewConfig(view) {
   const config = PLAYBACK_VIEWS[view];

   if (config === undefined) {
      throw new Error(`Unknown playback view '${view}'. Use one of: ${PLAYBACK_VIEW_NAMES.join(', ')}.`);
   }

   return config;
}
